import { toSnakeCase } from "@estaly/ui";

import { securedAxiosInstance } from "../axios";

class AnalyticsService {
  fetchIndex({ startDate, endDate, comparisonType, organizationId, stores, categories, insurerManagerIds } = {}) {
    return securedAxiosInstance.get("/insurer/analytics", {
      params: {
        start_date: startDate,
        end_date: endDate,
        comparison_type: comparisonType,
        organization_id: organizationId,
        stores,
        categories,
        insurer_manager_ids: insurerManagerIds,
      },
    });
  }

  getOrganizations(startDate, endDate, filters = {}) {
    return securedAxiosInstance.get("/insurer/analytics/retail/organizations", {
      params: toSnakeCase({ start: startDate, end: endDate, ...filters }),
    });
  }

  getStores(organizationId, startDate, endDate, filters = {}) {
    const params = { start: startDate, end: endDate, ...filters };
    if (organizationId) params.organizationId = organizationId;
    return securedAxiosInstance.get("/insurer/analytics/retail/stores", { params: toSnakeCase(params) });
  }

  getSellers(storeId, startDate, endDate, filters = {}) {
    return securedAxiosInstance.get("/insurer/analytics/retail/sellers", {
      params: toSnakeCase({ storeId, start: startDate, end: endDate, ...filters }),
    });
  }
}

export default new AnalyticsService();
